export enum ButtonLinkAppearance {
  SECONDARY = 'secondary',
  SECONDARY_LIGHT = 'secondary-light',
  MAIN_LIGHT = 'main-light',
  TERTIARY = 'tertiary',
  ERROR = 'error',
}
